/*
 * @Author: Dzy
 * @Date: 2022-07-18 10:58:39
 * @LastEditors: xiangwenheng
 * @LastEditTime: 2023-04-28 14:40:32
 * @Description: axios 请求方法统一封装
 */
import axios from 'axios'
import dayjs from 'dayjs'
import { arrayBufferToStr, clearStorage } from './tools'
import { message } from 'ant-design-vue'

// let Authorization
// let orgId
const random = dayjs().valueOf()
axios.defaults.timeout = 60000

export const setHeader = (token, authorization) => {
  axios.defaults.headers.common['Authorization'] = authorization
  if (process.env.NODE_ENV == 'development') {
    // axios.defaults.headers.common['X-Develop-Target-IP'] = '172.16.40.8' //后台-满超
    // axios.defaults.headers.common['X-Develop-Target-IP'] = '172.16.40.220' //后台-罗云
    // axios.defaults.headers.common['X-Develop-Target-IP'] = '172.16.2.102' //后台-张乔
    axios.defaults.headers.common['X-Develop-Target-IP'] = '172.16.40.26' //后台-凯旋
    // axios.defaults.headers.common['X-Develop-Target-IP'] = '172.16.0.133' //后台-唐念
  }

}

export const setUserHeader = (orgId) => {
  axios.defaults.headers.common['orgId'] = orgId
  // orgId = orgId
}

const lanMap = {
  zh_cn: 'zh-CN,zh;',
  zh_tw: 'zh-TW,zh;',
  en_us: 'en-US,en;'
}
export const setLanguageHeader = (language) => {
  axios.defaults.headers.common['accept-language'] = lanMap[language]
}

export const getAbsolutePath = (method) => {
  return (axios.defaults.baseURL || '') + method
}

axios.interceptors.request.use((req) => {
  req.url = process.env.VUE_APP_BASEPATH + req.url
  return req
})

axios.interceptors.response.use(
  (res) => {
    return res
  },
  (error) => {
    if (error.response) {
      if (error.response.status == 401) {
        message.warn('当前登录状态已过期，请重新登录')
        clearStorage()
        setTimeout((window.location.href = window.location.origin + '/busi/'), 1000)
      } else if (error.response.status == 403) {
        window.location.replace(window.location.origin + '/busi/403')
      }
    }
  }
)

export const request = async function (url, data, method = 'post', timeout) {
  try {
    const response = await axios.request({
      url,
      method,
      data,
      timeout,
      transformResponse: function (data) {
        if (typeof data === 'string') {
          data = JSON.parse(data)
        }
        return data
      },
      headers: {
        // Authorization: Authorization,
        // orgId: orgId,
        platform: 'MISSION',
        timestamp: random,
        requestId: random + Math.random().toString(36).slice(2)
      }
    })
    return response.data
  } catch (response) {
    return {
      code: response.status,
      msg: '数据请求出现异常，请检查网络及服务器状态是否正常。'
    }
  }
}

export const requestGet = async function (url, data) {
  try {
    const response = await axios.request({
      url,
      method: 'get',
      params: data,
      transformResponse: function (data) {
        if (typeof data === 'string') {
          data = JSON.parse(data)
        }
        return data
      },
      headers: {
        // Authorization: Authorization,
        // orgId: orgId,
        platform: 'MISSION',
        timestamp: random,
        requestId: random + Math.random().toString(36).slice(2)
      }
    })
    return response.data
  } catch (response) {
    return {
      code: response.status,
      msg: '数据请求出现异常，请检查网络及服务器状态是否正常。'
    }
  }
}

export const requestBlob = (url, params, method = 'get') => {
  return axios.request({
    url,
    params,
    method,
    responseType: 'blob',
    headers: {
      // Authorization: Authorization,
      platform: 'MISSION',
      timestamp: random,
      requestId: random + Math.random().toString(36).slice(2)
    }
  })
}

export const requestBlobPost = (url, data, method = 'post', timeout = 15000) => {
  return axios.request({
    url,
    method,
    data,
    timeout: 100000000,
    transformResponse: function (data) {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      return data
    },
    responseType: 'blob',
    headers: {
      // Authorization: Authorization,
      platform: 'MISSION',
      timestamp: random,
      requestId: random + Math.random().toString(36).slice(2)
    }
  })
}

export const requestBlobPostX = async function (url, data, method = 'post') {
  const response = await axios.request({
    url,
    method,
    data,
    transformResponse: function (data) {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      return data
    },
    'Content-Type': 'multipart/form-data',
    responseType: 'blob',
    headers: {
      // Authorization: Authorization,
      platform: 'MISSION',
      timestamp: random,
      requestId: random + Math.random().toString(36).slice(2)
    }
  })
  return response
}

export const requestArrayBuffer = async (url, data, method = 'get') => {
  const response = await axios.request({
    url,
    data,
    method,
    responseType: 'arraybuffer',
    headers: {
      // Authorization: Authorization,
      platform: 'MISSION',
      timestamp: random,
      requestId: random + Math.random().toString(36).slice(2)
    }
  })
  if (response.headers['content-type'] === 'application/json') {
    const str = await arrayBufferToStr(response.data)
    const data = JSON.parse(str)
    return data
  } else {
    return response.data
  }
}

export const requestByFormData = async (url, payload, method = 'post') => {
  let formDataObj = new FormData()
  for (let key in payload) {
    formDataObj.append(key, payload[key])
  }
  const response = await axios.request({
    url,
    method,
    data: formDataObj,
    transformResponse: function (data) {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      if (typeof data.result === 'string') {
        data.result = data.result === 'true'
      }
      return data
    },
    headers: {
      // Authorization: Authorization,
      platform: 'MISSION',
      timestamp: random,
      requestId: random + Math.random().toString(36).slice(2)
    },
    'Content-Type': 'multipart/form-data'
  })
  return response.data
}

export const requestByPromise = async function (url, data, method = 'post', timeout = 15000) {
  return axios
    .request({
      url,
      method,
      data,
      timeout: timeout,
      transformResponse: function (data) {
        if (typeof data === 'string') {
          data = JSON.parse(data)
        }
        return data
      },
      headers: {
        // Authorization: Authorization,
        platform: 'MISSION',
        timestamp: random,
        requestId: random + Math.random().toString(36).slice(2)
      }
    })
    .then((resolve) => resolve.data)
    .catch((reject) => reject.data)
}

export const requestByPromise2 = async function (url, data, method = 'post', timeout = 15000) {
  return axios
    .request({
      url,
      method,
      data,
      timeout: timeout,
      transformResponse: function (data) {
        if (typeof data === 'string') {
          data = JSON.parse(data)
        }
        if (typeof data.result === 'string') {
          data.result = data.result === 'true'
        }
        return data
      },
      headers: {
        // Authorization: Authorization,
        platform: 'MISSION',
        timestamp: random,
        requestId: random + Math.random().toString(36).slice(2),
      },
      'Content-Type': 'multipart/form-data',
      responseType: 'blob'
    })
    .then((resolve) => resolve)
    .catch((reject) => reject)
}


export const requestByFormDataBlob = async (url, payload, method = 'post') => {
  let formDataObj = new FormData()
  for (let key in payload) {
    formDataObj.append(key, payload[key])
  }
  const response = await axios.request({
    url,
    method,
    data: formDataObj,
    timeout: 100000000,
    transformResponse: function (data) {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      if (typeof data.result === 'string') {
        data.result = data.result === 'true'
      }
      return data
    },
    headers: {
      // Authorization: Authorization,
      platform: 'MISSION',
      timestamp: random,
      requestId: random + Math.random().toString(36).slice(2)
    },
    'Content-Type': 'multipart/form-data',
    responseType: 'blob'
  })
  return response
}

export const requestByFormDataFilesBlob = async (url, payload, files, method = 'post') => {
  let formDataObj = new FormData()
  for (let key in payload) {
    formDataObj.append(key, payload[key])
  }
  for (let file of files) {
    formDataObj.append('files', file)
  }
  const response = await axios.request({
    url,
    method,
    data: formDataObj,
    timeout: 100000000,
    transformResponse: function (data) {
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      if (typeof data.result === 'string') {
        data.result = data.result === 'true'
      }
      return data
    },
    headers: {
      // Authorization: Authorization,
      platform: 'MISSION',
      timestamp: random,
      requestId: random + Math.random().toString(36).slice(2)
    },
    'Content-Type': 'multipart/form-data'
  })
  return response
}

export const requestByThirdPath = async (url) => {
  // fetch(url, { redirect: 'manual' }).then(response  => {
  //   console.log(response.headers.get('Location'))
  // })
  try {
    const response = await axios.get(url, {
      headers: {
        // Authorization: Authorization,
        platform: 'MISSION',
        timestamp: random,
        requestId: random + Math.random().toString(36).slice(2)
      },
      'Content-Type': 'multipart/form-data'
    })
    if (response.status === 200 && !response.data.code) {
      const redirectUrl = response.request.responseURL;
      window.location.href = redirectUrl;
    } else {
      if (response.data.code) {
        if (response.data.code == 500) {
          message.warn(response.data.msg)
        }
      }
    }
  } catch (error) {
  }
}

export default request
